module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tiles"
  }, [_c('el-collapse', {
    staticClass: "formset__list"
  }, _vm._l((_vm.form.tiles), function(tile, i) {
    return _c('div', {
      staticClass: "formset__item"
    }, [_c('el-collapse-item', {
      attrs: {
        "name": i
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('formset-header', {
      attrs: {
        "label": ("" + (tile.title_pl || 'Nowy kafel')),
        "items": _vm.form.tiles,
        "errors": _vm.checkForErrors(_vm.errors.tiles, [i]),
        "index": i
      },
      on: {
        "update:items": function($event) {
          return _vm.$set(_vm.form, "tiles", $event)
        }
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": ""
      }
    }, [_c('el-tooltip', {
      attrs: {
        "placement": "top",
        "effect": "light"
      }
    }, [_c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('img', {
      attrs: {
        "src": "/static/help/tile.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "info",
        "size": "mini"
      }
    }, [_c('i', {
      staticClass: "fa fa-question-circle"
    }), _vm._v(" Pomocnicze informacje dotyczące grafik\n                            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Tytuł",
        "error": _vm.errors.tiles && _vm.errors.tiles[i] && _vm.errors.tiles[i][_vm.addLanguageSuffix('title')]
      }
    }, [_c('el-input', {
      model: {
        value: (tile[_vm.addLanguageSuffix('title')]),
        callback: function($$v) {
          _vm.$set(tile, _vm.addLanguageSuffix('title'), $$v)
        },
        expression: "tile[addLanguageSuffix('title')]"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tła",
        "error": _vm.errors.tiles && _vm.errors.tiles[i] && _vm.errors.tiles[i]['bg_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (tile.bg_color),
        callback: function($$v) {
          _vm.$set(tile, "bg_color", $$v)
        },
        expression: "tile.bg_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Kolor tekstu",
        "error": _vm.errors.tiles && _vm.errors.tiles[i] && _vm.errors.tiles[i]['text_color']
      }
    }, [_c('el-color-picker', {
      model: {
        value: (tile.text_color),
        callback: function($$v) {
          _vm.$set(tile, "text_color", $$v)
        },
        expression: "tile.text_color"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Zdjęcie",
        "error": _vm.errors.tiles && _vm.errors.tiles[i] && _vm.errors.tiles[i]['image']
      }
    }, [_c('image-input-component', {
      model: {
        value: (tile.image),
        callback: function($$v) {
          _vm.$set(tile, "image", $$v)
        },
        expression: "tile.image"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Przycisk"
      }
    }, [_c('link-component', {
      key: tile.key || tile.id,
      attrs: {
        "errors": _vm.errors.tiles && _vm.errors.tiles[i] && _vm.errors.tiles[i]['link']
      },
      model: {
        value: (tile.link),
        callback: function($$v) {
          _vm.$set(tile, "link", $$v)
        },
        expression: "tile.link"
      }
    })], 1)], 2)], 1)
  }), 0), _vm._v(" "), _c('el-button', {
    staticClass: "fluid",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addSection
    }
  }, [_vm._v("\n            Dodaj kafel\n        ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2de1f1d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/InformationTilesWidget.vue
// module id = 729
// module chunks = 0